<template>
<header id="header" :class="{'is-collapsed': collapsed}">
    <nav class="navbar is-transparent">
        <div class="navbar-brand">
            <h1 class="navbar-item" v-if="$route.name == 'Homepage'">
                <router-link id="logo" rel="start" :to="{ name: 'Homepage' }">
                    <img :alt="site_data.siteconfig.logo.title" class="is-block" v-if="site_data.siteconfig.logo" :src="site_data.siteconfig.logo.url" />
                    <img v-else :alt="site_data.siteconfig.title" class="is-block"  src="@/assets/ts-primary-RGB-rev.svg" />
                </router-link>
            </h1>
            <router-link class="navbar-item" id="logo" rel="start" v-else :to="{ name: 'Homepage' }">
                <img :alt="site_data.siteconfig.logo.title" class="is-block" v-if="site_data.siteconfig.logo" :src="site_data.siteconfig.logo.url" />
                <img v-else :alt="site_data.siteconfig.title" class="is-block"  src="@/assets/ts-primary-RGB-rev.svg" />
            </router-link>
            <div v-on:click="show_mobile_menu" :class="{'navbar-burger': true, 'burger': true, 'is-active': mobile_menu_is_active}" data-target="mobile-menu">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <router-link to="/search" class="navbar-item btn-search">
                <span class="icon">
                    <i class="fas fa-search"></i>
                </span>
            </router-link>
        </div>
        <div id="mobile-menu" :class="{'navbar-menu': true, 'is-active': mobile_menu_is_active}" :style="heightstyle">
            <div class="navbar-end">
                <template v-for="item, i in site_data.navigation">
                    <component
                        v-if="!item.sub"
                        class="navbar-item"
                        :key="i"
                        :is="item.external || item.new_tab ? 'a' : 'router-link'"
                        :href="item.external || item.new_tab ? item.url : null"
                        :to="item.external || item.new_tab ? null : item.url"
                        :target="item.new_tab ? '_blank' : null"
                    >{{item.label}}</component>
                    <div v-else class="navbar-item has-dropdown is-hoverable" @mouseenter="alignSubmenu" id="main-nav">
                        <router-link :to="item.url" :class="['navbar-link', 'is-arrowless']" :key="i" >
                            {{item.label}}
                            <button v-if="is_touching" @click.prevent="item.toggled = !item.toggled" :class="['navbar-link__toggle-button', {'is-toggled': item.toggled}]"><span class="icon"><i class="fas fa-angle-down"></i></span></button>
                        </router-link>

                        <component v-if="!is_touching" :is="'StandardSubmenu'" :item="item.sub" :submenu_x="submenu_x" />

                        <div v-else :class="['navbar-dropdown', {'is-toggled': item.toggled}]">
                            <template v-if="item.sub.type == 'Normal'">
                                <template v-for="first_level, n in item.sub.sub">
                                    <router-link v-if="first_level.sub && !first_level.sub.length" :to="first_level.url" class="navbar-item" :key="'submenuitem-' + n">{{first_level.label}}</router-link>
                                    <div v-else-if="first_level.sub && first_level.sub.length" class="navbar-item has-dropdown is-hoverable">
                                        <router-link :to="first_level.url" class="navbar-link is-arrowless" :key="'submenuitem-' + n">{{first_level.label}}
                                           <button @click.prevent="first_level.toggled = !first_level.toggled" :class="['navbar-link__toggle-button', {'is-toggled': first_level.toggled}]"><span class="icon"><i class="fas fa-angle-down"></i></span></button>
                                        </router-link>
                                        <div :class="['navbar-dropdown', {'is-toggled': first_level.toggled}]">
                                            <router-link v-for="second_level, k in first_level.sub" :to="second_level.url" class="navbar-item" :key="'subsubmenuitem-' + k">{{second_level.label}}</router-link>
                                        </div>
                                    </div>
                                </template>
                            </template>
                            <template v-else>
                                <template v-for="first_level, n in item.sub.sub.sub">
                                    <router-link v-if="first_level.sub && !first_level.sub.length" :to="first_level.url" class="navbar-item" :key="'submenuitem-' + n">{{first_level.label}}</router-link>
                                    <div v-else-if="first_level.sub && first_level.sub.length" class="navbar-item has-dropdown is-hoverable">
                                        <router-link :to="first_level.url" class="navbar-link is-arrowless" :key="'submenuitem-' + n">{{first_level.label}}
                                           <button @click.prevent="first_level.toggled = !first_level.toggled" :class="['navbar-link__toggle-button', {'is-toggled': first_level.toggled}]"><span class="icon"><i class="fas fa-angle-down"></i></span></button>
                                        </router-link>
                                        <div :class="['navbar-dropdown', {'is-toggled': first_level.toggled}]">
                                            <router-link v-for="second_level, k in first_level.sub" :to="second_level.url" class="navbar-item" :key="'subsubmenuitem-' + k">{{second_level.label}}</router-link>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                </template>
                <div v-if="!is_touching" class="navbar-item has-dropdown is-hoverable" style="padding-left: 0;">
                    <router-link to="/search" class="navbar-link is-arrowless btn-search">
                        <span class="icon">
                            <i class="fas fa-search"></i>
                        </span>
                    </router-link>
                    <div v-if="$route.path != '/search'" class="navbar-menu__submenu navbar-dropdown">
                        <div class="container">
                            <div class="columns navbar-menu__submenu__titles is-variable is-8">
                                <div class="column is-narrow no-wrap navbar-menu__submenu__titles__title">Search</div>
                            </div>
                            <div class="columns is-multiline navbar-menu__submenu__submenu">
                                <div class="column">
                                    <form class="form" method="post" @submit.prevent="onSearchSubmit">
                                        <fieldset>
                                            <div class="field has-addons">
                                              <div class="control is-fullwidth">
                                                <input class="input is-large" type="text" v-model="term" placeholder="Search term...">
                                              </div>
                                              <div class="control">
                                                <button type="submit" class="button is-purple is-large">
                                                  Search
                                                </button>
                                              </div>
                                            </div>
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</header>
</template>
<script>
import * as components from '../blocks/modules/elements';
import WindowResizeHandler from '../mixins/WindowResizeHandler';
export default {
    name: 'Header',
    props: ['site_data'],
    mixins: [ WindowResizeHandler ],
    components,
    data()
    {
        return {
            term        :   this.$route.query.term ? this.$route.query.term : null,
            max_height  :   null,
            is_touching :   false,
            collapsed   :   false,
            mobile_menu_is_active: false,
            submenu_x : 0,
        };
    },
    mounted()
    {
        this.$bus.$on('onWindowScroll', this.handle_scroll);
    },
    beforeDestroy()
    {
        this.$bus.$off('onWindowScroll', this.handle_scroll);
    },
    computed    :   {
        heightstyle()
        {
            if (!this.max_height) return null;

            return 'max-height: ' + this.max_height + 'px;';
        }
    },
    watch   :   {
        mobile_menu_is_active(nv, ov)
        {
            if (!nv) {
                this.max_height =   null;
            } else {
                this.recalc();
            }
        }
    },
    methods: {
        onSearchSubmit() {
            let q = {
                term: this.term
            }

            this.$router.push({
                path: '/search',
                query: q
            }).catch(err => {})
        },
        handle_window_resize(width)
        {
            this.is_touching    =   width <= 1023;
        },
        handle_scroll(top)
        {
            if (top >= 80) {
                this.collapsed  =   true;
            } else {
                this.collapsed  =   false;
            }

            this.recalc();
        },
        recalc()
        {
            this.max_height =   this.mobile_menu_is_active ? $(window).height() - $(this.$el).find('.navbar-brand').outerHeight() : null;
        },
        click_to_close: function(e) {
            let target = $(e.target);
            if (!target.is('.burger') &&
                target.parents('.burger').length == 0 &&
                !target.is('.navbar-item') &&
                target.parents('.navbar-item').length == 0) {

                this.mobile_menu_is_active = false;
                $(window).unbind('mousedown', this.click_to_close);
            }
        },
        show_mobile_menu: function(e) {
            e.preventDefault();
            $(window).unbind('mousedown', this.click_to_close).on('mousedown', this.click_to_close);
            this.mobile_menu_is_active = !this.mobile_menu_is_active;
        },
        alignSubmenu(e) {
            if (! this.is_touching) {
                const rect = e.target.getBoundingClientRect();
                this.submenu_x = rect.left + rect.width / 2;

                var alignDiv = e.target.querySelector('.standard-submenu');
                var container = e.target.querySelector('.container');
                if (container) {
                    var style = window.getComputedStyle(container);
                    var marginLeft = parseInt(style.marginLeft);
                }

                var menu = e.target.querySelector('.navbar-menu__submenu');
                if (menu) {
                    var menu_style = window.getComputedStyle(menu);
                    var paddingLeft = parseInt(menu_style.paddingLeft);
                }

                this.submenu_x = `${this.submenu_x - alignDiv.clientWidth / 2 - marginLeft - paddingLeft}px`;
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/Header.vue